import { apiWeeklyPlanner } from '~constants/api';

import { put } from '~libs/genericAction';
import { createThunks } from '~libs/reduxUtils';

export const typePrefix = 'weekly-planner-visualise';

const config = [{ actionType: 'visualiseDistance', apiPath: `${apiWeeklyPlanner}/visualise/distance`, method: put }];

export const { visualiseDistance } = createThunks(typePrefix, config);
